export default __webpack_public_path__ + "static/media/qr_appstore_ikara.84b0622a.svg";